
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5QLLH", function(module, exports) {
/* TemplatePreview.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $bQm3c = parcelRequire("bQm3c");

/* Preview.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $9hlns = parcelRequire("9hlns");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $fGzMp = parcelRequire("fGzMp");


var $bkTn0 = parcelRequire("bkTn0");

/* PreviewRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 





var $7sObp = parcelRequire("7sObp");


var $jSnXV = parcelRequire("jSnXV");


var $10Oe6 = parcelRequire("10Oe6");


var $dPJCf = parcelRequire("dPJCf");


var $3jwuS = parcelRequire("3jwuS");


var $3WalV = parcelRequire("3WalV");

var $dro0K = parcelRequire("dro0K");


var $a5rdE = parcelRequire("a5rdE");





var $h2spB = parcelRequire("h2spB");

/* TinyPreviewRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 











// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $12ad2bda5768491f$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4fkly",
            __cmplp.className
        ])
    });
});
const $12ad2bda5768491f$export$3bb0d913054d3275 = ({ previewString: previewString })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // We're not using <ExperienceSuccess /> because this component isn't actually de-mounting properly, the current logic just hides it.
    experienceTracker.succeed({
        name: (0, $irVI7.TEMPLATE_PREVIEW_EXPERIENCE)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12ad2bda5768491f$var$Wrapper, {
        dangerouslySetInnerHTML: {
            __html: previewString
        }
    });
};


const $26fa345f29e044ce$var$SCROLL_DEBOUNCE_TIME = 300;
const $26fa345f29e044ce$var$SCALE = 0.65; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26fa345f29e044ce$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isScrollable: isScrollable, marginBottom: marginBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1nrssru": (0, $7sObp.default)(__cmplp.marginBottom, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4v47k _11q71bhr _t9ecdp6k _8hrz1nty _1bsb16hx _18m91wug _vchhusvi _otyr19nu",
            __cmplp.isScrollable ? "_4t3i16hx" : "_4t3i1wug",
            __cmplp.className
        ])
    });
});
const $26fa345f29e044ce$var$InteractionBlocker = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_lcxvglyw _uiztglyw",
            __cmplp.className
        ])
    });
});
const $26fa345f29e044ce$var$Renderer = ({ template: template, previewString: previewString, representation: representation, fabricDataProviders: fabricDataProviders })=>{
    if (representation === 'view') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $12ad2bda5768491f$export$3bb0d913054d3275), {
        previewString: previewString
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h2spB.AdfPreviewRenderer), {
        template: template,
        previewString: previewString,
        fabricDataProviders: fabricDataProviders
    });
};
const $26fa345f29e044ce$export$8ce5f720dc007208 = ({ templateBody: templateBody, template: template, isScrollable: isScrollable, error: error, marginBottom: marginBottom, fabricDataProviders: fabricDataProviders })=>{
    const itemModuleCompleteKey = template?.itemModuleCompleteKey;
    const contentBlueprintId = template?.contentBlueprintId;
    const previewString = templateBody?.body?.value;
    const representation = templateBody?.body?.representation;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { fireAnalyticsEventWithTemplateData: fireAnalyticsEventWithTemplateData } = (0, $42omo.useContext)((0, $a5rdE.PreviewAnalyticsContext));
    const wrapperRef = (0, $42omo.useRef)();
    const prevPreviewString = (0, $42omo.useRef)();
    const timestamp = (0, $42omo.useRef)(0);
    const isPreviewAvailable = !!previewString && !!representation && (0, $bkTn0.isValidPreviewRepresentation)(representation);
    if (previewString && previewString !== prevPreviewString.current) timestamp.current = new Date().getTime();
    (0, $42omo.useLayoutEffect)(()=>{
        if (previewString && previewString !== prevPreviewString.current) {
            fireAnalyticsEventWithTemplateData({
                type: 'sendTrackEvent',
                data: {
                    source: 'templateDrawer',
                    action: 'rendered',
                    actionSubject: 'templatePreview',
                    attributes: {
                        renderTimeMs: new Date().getTime() - timestamp.current
                    }
                }
            });
            prevPreviewString.current = previewString;
        }
    }, [
        previewString,
        fireAnalyticsEventWithTemplateData
    ]);
    (0, $42omo.useEffect)(()=>{
        if (wrapperRef.current) wrapperRef.current.scrollTop = 0;
    }, [
        previewString
    ]); // Add inert attribute to Wrapper to for Voice over to skip the preview and avoid keyboard tab on some of the elements on the preview
    // TS wont recognise this attribute, so we have to manually add this to the wrapper.
    (0, $42omo.useEffect)(()=>{
        if (wrapperRef.current) wrapperRef.current.setAttribute('inert', '');
    }, []);
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEventWithTemplateData({
            type: 'sendScreenEvent',
            data: {
                name: 'templatePreview',
                attributes: {
                    isPreviewAvailable: isPreviewAvailable,
                    currentRouteName: routeDataRef?.current?.routeName,
                    currentRouteIsLive: isLivePage
                }
            }
        });
    }, [
        isPreviewAvailable,
        fireAnalyticsEventWithTemplateData,
        routeDataRef,
        isLivePage
    ]);
    const handleScroll = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            fireAnalyticsEventWithTemplateData({
                type: 'sendUIEvent',
                data: {
                    source: 'templateDrawer',
                    action: 'scrolled',
                    actionSubject: 'templatePreview'
                }
            });
        }, $26fa345f29e044ce$var$SCROLL_DEBOUNCE_TIME), [
        fireAnalyticsEventWithTemplateData
    ]);
    (0, $42omo.useEffect)(()=>{
        // this event is sent from useEffect to avoid sending more than one
        if (itemModuleCompleteKey === (0, $3WalV.BLOG_POST_ITEM_MODULE_COMPLETE_KEY) || contentBlueprintId === (0, $10Oe6.BLOG_CONTENT_BLUEPRINT_ID)) fireAnalyticsEventWithTemplateData({
            type: 'sendTrackEvent',
            data: {
                source: 'templateDrawer',
                action: 'rendered',
                actionSubject: 'templatePreview',
                actionSubjectId: 'customBlogPostPreview'
            }
        });
    }, [
        itemModuleCompleteKey,
        contentBlueprintId,
        fireAnalyticsEventWithTemplateData
    ]);
    if (itemModuleCompleteKey === (0, $3WalV.BLOG_POST_ITEM_MODULE_COMPLETE_KEY) || contentBlueprintId === (0, $10Oe6.BLOG_CONTENT_BLUEPRINT_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3WalV.CustomBlogPostPreview), null);
    if (!isPreviewAvailable) {
        fireAnalyticsEventWithTemplateData({
            type: 'sendTrackEvent',
            data: {
                source: 'templateDrawer',
                action: 'rendered',
                actionSubject: 'templatePreview',
                actionSubjectId: 'defaultImage'
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dro0K.NoPreviewAvailable), {
            error: error
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26fa345f29e044ce$var$Wrapper, {
        isScrollable: isScrollable,
        marginBottom: marginBottom,
        ref: wrapperRef,
        onScroll: handleScroll,
        "data-testid": "template-preview-scroll-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26fa345f29e044ce$var$InteractionBlocker, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26fa345f29e044ce$var$Renderer, {
        template: template,
        previewString: previewString,
        representation: representation,
        fabricDataProviders: fabricDataProviders
    })));
};






var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");





var $2dIMm = parcelRequire("2dIMm");

var $00ee4036e3a00231$exports = {};
$00ee4036e3a00231$exports = new URL("loadingErrorIcon.3c97c605.svg", import.meta.url).toString();


const $e698c3566c3c2f14$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    title: {
        id: "template-preview.errors.loading.title",
        defaultMessage: "We couldn\u2019t load the preview"
    },
    message: {
        id: "template-preview.errors.loading.message",
        defaultMessage: // eslint-disable-next-line no-restricted-syntax
        "We're having trouble loading the preview right now. {lineBreak} Refresh the page to try again."
    },
    iconDescription: {
        id: "template-preview.errors.loading.icon.description",
        defaultMessage: "Can\u2019t display the preview"
    }
});
const $e698c3566c3c2f14$export$64ad2515d3c89d5 = (0, $gmMgo.default)(({ intl: intl, error: error })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $42omo.useContext)((0, $a5rdE.PreviewAnalyticsContext));
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'templateDrawer',
                action: 'error',
                actionSubject: 'templatePreview',
                actionSubjectId: 'templatePreviewFetchBodiesError',
                attributes: {
                    errorMessage: error.message
                }
            }
        });
    }, [
        error,
        fireAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2dIMm.PreviewMessage), {
        title: intl.formatMessage($e698c3566c3c2f14$export$a7357cdd1f0b0168.title),
        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$e698c3566c3c2f14$export$a7357cdd1f0b0168.message,
            values: {
                lineBreak: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)
            }
        }),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($00ee4036e3a00231$exports))),
        iconDescription: intl.formatMessage($e698c3566c3c2f14$export$a7357cdd1f0b0168.iconDescription),
        testId: "template-preview-loading-error"
    });
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6119dc77b64545ae$var$CenteredContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $6119dc77b64545ae$export$133773870222880f = ({ templateBody: templateBody, isLoading: isLoading, error: error, template: template, isScrollable: isScrollable, marginBottom: marginBottom, fabricDataProviders: fabricDataProviders })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    if (isLoading && !(0, $bkTn0.hasCustomPreview)(template)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6119dc77b64545ae$var$CenteredContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "medium",
        testId: "template-preview-spinner"
    }));
    if (error && !(0, $bkTn0.hasCustomPreview)(template)) {
        if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error)) experienceTracker.succeed({
            name: (0, $irVI7.TEMPLATE_PREVIEW_EXPERIENCE)
        });
        else (0, $fGzMp.stopExperienceOnError)((0, $irVI7.TEMPLATE_PREVIEW_EXPERIENCE), error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e698c3566c3c2f14$export$64ad2515d3c89d5), {
            error: error
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26fa345f29e044ce$export$8ce5f720dc007208), {
        templateBody: templateBody,
        error: error,
        template: template,
        isScrollable: isScrollable,
        marginBottom: marginBottom,
        fabricDataProviders: fabricDataProviders
    });
};






var $ibzAc = parcelRequire("ibzAc");


var $4FxUL = parcelRequire("4FxUL");


var $32x2E = parcelRequire("32x2E");


var $c4QoG = parcelRequire("c4QoG");

const $39ec44a147702e3f$export$29d807bc39faaa49 = (options)=>{
    const { cloudId: cloudId, userId: userId, templateIds: templateIds, spaceKey: spaceKey, currentTemplateId: currentTemplateId } = options;
    const dataProviders = (0, $4FxUL.default).create({});
    dataProviders.setProvider('emojiProvider', (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    }));
    const contextIdentifierProvider = ()=>{
        const objectId = JSON.stringify({
            templateId: currentTemplateId,
            spaceKey: spaceKey
        });
        return Promise.resolve({
            containerId: spaceKey,
            objectId: objectId,
            product: 'confluence'
        });
    };
    dataProviders.setProvider('contextIdentifierProvider', contextIdentifierProvider());
    dataProviders.setProvider('mediaProvider', (0, $c4QoG.createRendererTemplateMediaProvider)({
        spaceKey: spaceKey,
        templateIds: templateIds
    }));
    return dataProviders;
};


const $9f3d2e2634338ebc$var$DEFAULT_NUM_PREVIEWS_TO_FETCH_AT_ONCE = 30;
const $9f3d2e2634338ebc$var$PREVIEW_MIN_HEIGHT = 500;
const $9f3d2e2634338ebc$var$DEFAULT_MARGIN_BOTTOM = 30;
const $9f3d2e2634338ebc$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isScrollable: isScrollable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71bhr",
            __cmplp.isScrollable ? "_4t3i1osq" : "_4t3idgin",
            __cmplp.className
        ])
    });
});
const $9f3d2e2634338ebc$export$48a171bbad47b95a = ({ spaceKey: spaceKey, templates: templates, currentTemplateIndex: currentTemplateIndex = -1, numPreviewsToFetchAtOnce: numPreviewsToFetchAtOnce = $9f3d2e2634338ebc$var$DEFAULT_NUM_PREVIEWS_TO_FETCH_AT_ONCE, isScrollable: isScrollable = false, marginBottom: marginBottom = $9f3d2e2634338ebc$var$DEFAULT_MARGIN_BOTTOM })=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const ids = (0, $42omo.useMemo)(()=>(0, $bkTn0.getTemplateIdsToFetch)(templates, currentTemplateIndex, numPreviewsToFetchAtOnce), [
        templates,
        currentTemplateIndex,
        numPreviewsToFetchAtOnce
    ]);
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query TemplatePreviewTemplateBodiesQuery($spaceKey:String!$ids:[String!]!){templateBodies(spaceKey:$spaceKey ids:$ids){nodes{id body{value representation}}}}`, {
        variables: {
            spaceKey: spaceKey,
            ids: ids
        },
        skip: !spaceKey || !templates.length || !ids.length
    });
    const currentTemplate = templates[currentTemplateIndex];
    const currentTemplateId = currentTemplate ? (0, $bkTn0.getTemplateId)(currentTemplate) : '';
    const fabricDataProviders = (0, $42omo.useMemo)(()=>(0, $39ec44a147702e3f$export$29d807bc39faaa49)({
            cloudId: cloudId,
            userId: userId,
            templateIds: ids,
            spaceKey: spaceKey,
            currentTemplateId: currentTemplateId
        }), [
        cloudId,
        userId,
        ids,
        spaceKey,
        currentTemplateId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9f3d2e2634338ebc$var$Wrapper, {
        isScrollable: isScrollable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6119dc77b64545ae$export$133773870222880f), {
        templateBody: (0, $bkTn0.getBodyForTemplate)(data, currentTemplate),
        isLoading: loading,
        error: error,
        template: currentTemplate,
        isScrollable: isScrollable,
        marginBottom: marginBottom,
        fabricDataProviders: fabricDataProviders
    }));
};
module.exports["TemplatePreview"] = $9f3d2e2634338ebc$export$48a171bbad47b95a;

});

parcelRegister("bkTn0", function(module, exports) {

var $c5QRx = parcelRequire("c5QRx");


var $3WalV = parcelRequire("3WalV");

const $ac80e580fa651d90$export$c61afba3696e8231 = (previewRect, itemRect, hasDynamicPositioning = false, isBottomPositioned = false, isHorizontallyCentered = false)=>{
    const { scrollY: scrollY } = window;
    let top = scrollY + (itemRect.top + itemRect.height / 2 - previewRect.height / 2);
    if (top < scrollY + (0, $c5QRx.TOP_BAR_HEIGHT) + (0, $c5QRx.VERTICAL_MARGIN)) top = scrollY + (0, $c5QRx.TOP_BAR_HEIGHT) + (0, $c5QRx.VERTICAL_MARGIN);
    if (top + previewRect.height > scrollY + window.innerHeight - (0, $c5QRx.VERTICAL_MARGIN)) top = scrollY + window.innerHeight - (0, $c5QRx.VERTICAL_MARGIN) - previewRect.height;
    if (isBottomPositioned) top = scrollY + itemRect.top - previewRect.height - (0, $c5QRx.BOTTOM_VERTICAL_MARGIN);
    let left = hasDynamicPositioning ? $ac80e580fa651d90$var$calculateDynamicPreviewPosition(previewRect, itemRect) : itemRect.left - previewRect.width - (0, $c5QRx.DISTANCE_FROM_ITEM);
    if (isHorizontallyCentered) left = itemRect.left + itemRect.width / 2 - previewRect.width / 2;
    return {
        top: top,
        left: left
    };
};
const $ac80e580fa651d90$var$calculateDynamicPreviewPosition = (previewRect, itemRect)=>{
    const { screenWidth: screenWidth } = $ac80e580fa651d90$var$getWindowDimensions();
    const elementXPosition = (itemRect.left + itemRect.right) / 2;
    return elementXPosition < screenWidth / 2 ? itemRect.right + (0, $c5QRx.DISTANCE_FROM_IN_EDITOR_ELEMENT) : itemRect.left - previewRect.width - (0, $c5QRx.DISTANCE_FROM_IN_EDITOR_ELEMENT);
};
const $ac80e580fa651d90$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || template.itemModuleCompleteKey;
};
const $ac80e580fa651d90$export$c51ea4beddbf6923 = (data, template)=>{
    const nodes = data?.templateBodies?.nodes;
    if (!template || !nodes) return;
    const templateId = $ac80e580fa651d90$export$c095b4283dffab05(template);
    return nodes.find((node)=>node && node.id === templateId) ?? undefined;
};
const $ac80e580fa651d90$export$cf716d48c82d94b4 = (templates, templateIndex, chunkSize)=>{
    if (templateIndex < 0) return [];
    const chunk = Math.floor(templateIndex / chunkSize);
    const startIndex = chunk * chunkSize;
    return templates.slice(startIndex, startIndex + chunkSize).map($ac80e580fa651d90$export$c095b4283dffab05);
};
const $ac80e580fa651d90$export$a2c28b6902a80cd0 = (representation)=>{
    return [
        'view',
        'atlas_doc_format'
    ].includes(representation);
};
const $ac80e580fa651d90$export$60be922919b2b006 = (template)=>{
    if (!template) return false;
    return template.itemModuleCompleteKey === (0, $3WalV.BLOG_POST_ITEM_MODULE_COMPLETE_KEY);
};
const $ac80e580fa651d90$var$getWindowDimensions = ()=>{
    const { innerWidth: screenWidth } = window;
    return {
        screenWidth: screenWidth
    };
};
module.exports["calculatePreviewPosition"] = $ac80e580fa651d90$export$c61afba3696e8231;
module.exports["getTemplateId"] = $ac80e580fa651d90$export$c095b4283dffab05;
module.exports["getBodyForTemplate"] = $ac80e580fa651d90$export$c51ea4beddbf6923;
module.exports["getTemplateIdsToFetch"] = $ac80e580fa651d90$export$cf716d48c82d94b4;
module.exports["isValidPreviewRepresentation"] = $ac80e580fa651d90$export$a2c28b6902a80cd0;
module.exports["hasCustomPreview"] = $ac80e580fa651d90$export$60be922919b2b006;

});

parcelRegister("c5QRx", function(module, exports) {
const $de2cb5095a031a8d$export$37d1385b51ab57d = 32;
const $de2cb5095a031a8d$export$10b2836e22953ef1 = 10;
const $de2cb5095a031a8d$export$64bdf88fbfd838fe = 16;
const $de2cb5095a031a8d$export$6bba9ddbe7f71bbe = 82;
const $de2cb5095a031a8d$export$83dadb35ad1d1aeb = 20;
module.exports["DISTANCE_FROM_ITEM"] = $de2cb5095a031a8d$export$37d1385b51ab57d;
module.exports["DISTANCE_FROM_IN_EDITOR_ELEMENT"] = $de2cb5095a031a8d$export$10b2836e22953ef1;
module.exports["VERTICAL_MARGIN"] = $de2cb5095a031a8d$export$64bdf88fbfd838fe;
module.exports["TOP_BAR_HEIGHT"] = $de2cb5095a031a8d$export$6bba9ddbe7f71bbe;
module.exports["BOTTOM_VERTICAL_MARGIN"] = $de2cb5095a031a8d$export$83dadb35ad1d1aeb;

});

parcelRegister("b4zhJ", function(module, exports) {

var $dM1Gg = parcelRequire("dM1Gg");


var $42omo = parcelRequire("42omo");


var $dWCFT = parcelRequire("dWCFT");

const $4b5152b7d142b759$var$isClickable = (props)=>!!props.onClick;
class $4b5152b7d142b759$export$6341f9a885713487 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dM1Gg.DateLozenge), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.props.className,
            onClick: $4b5152b7d142b759$var$isClickable(this.props) ? this.handleOnClick : undefined,
            color: this.props.color
        }, this.renderContent());
    }
    constructor(...args){
        super(...args);
        this.handleOnClick = (event)=>{
            if ($4b5152b7d142b759$var$isClickable(this.props)) this.props.onClick(this.props.value, event);
        };
        this.renderContent = ()=>{
            if (this.props.children) {
                if (typeof this.props.children === 'function') return(// prettier-ignore
                // eslint-disable-next-line @typescript-eslint/ban-types
                this.props.children(this.props));
                return this.props.children;
            }
            return (0, $dWCFT.default)(this.props.value, this.props.format || '');
        };
    }
}
$4b5152b7d142b759$export$6341f9a885713487.displayName = 'Date';
$4b5152b7d142b759$export$6341f9a885713487.defaultProps = {
    format: 'dd/MM/yyyy',
    color: 'grey'
};
module.exports["Date"] = $4b5152b7d142b759$export$6341f9a885713487;

});

parcelRegister("dM1Gg", function(module, exports) {
/* DateLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $6603fd6b25dc5551$var$baseStyles = null;
const $6603fd6b25dc5551$var$onClickStyles = null;
const $6603fd6b25dc5551$var$colorStyles = {
    red: "_bfhk1vk5 _syaz9lu1 _irr31rtt",
    yellow: "_bfhkibhp _syazfb2s _irr31773",
    blue: "_bfhk1s93 _syaz16jw _irr31dy8",
    green: "_bfhkn729 _syazh55r _irr31wnw",
    purple: "_bfhkp2ly _syazqmo9 _irr31nm4",
    grey: "_bfhki8nm _syazi7uo _irr3plhp"
};
const $6603fd6b25dc5551$export$a9273d5fc6f7142c = (props)=>{
    const { className: className, color: color = 'grey', children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ...rest,
        className: (0, $gMc0m.default)([
            "_2rkofajl _19pkidpf _2hwxt94y _otyridpf _18u0t94y _v5641y8x _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _kqswh2mm _o5721q9c _80omn7od",
            props.onClick && "_80omtlke",
            $6603fd6b25dc5551$var$colorStyles[color],
            className
        ]),
        role: "button"
    }, children);
};
module.exports["DateLozenge"] = $6603fd6b25dc5551$export$a9273d5fc6f7142c;

});

parcelRegister("9914C", function(module, exports) {

var $dWCFT = parcelRequire("dWCFT");


var $72P30 = parcelRequire("72P30");

const $baec9e3e3fc5ba98$export$df19e8e99fa12ca2 = ({ userId: userId, isLicensed: isLicensed, timeZone: timeZone, dateFormat: dateFormat })=>{
    const isAnonymousUser = !userId || !isLicensed;
    const isLicensedWithTimezone = timeZone && !isAnonymousUser;
    const date = new Date();
    const currentTimezoneDate = isLicensedWithTimezone ? (0, $72P30.default)(date, timeZone, dateFormat) : (0, $dWCFT.default)(date, dateFormat);
    return currentTimezoneDate;
};
module.exports["getUserTimezoneDate"] = $baec9e3e3fc5ba98$export$df19e8e99fa12ca2;

});

parcelRegister("3WalV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2dIMm = parcelRequire("2dIMm");


var $ctTlX = parcelRequire("ctTlX");

const $de4db65843ec2cc7$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    title: {
        id: "template-preview.custom.blog-post.title",
        defaultMessage: "Bring your blog to life"
    },
    message: {
        id: "template-preview.custom.blog-post.message",
        defaultMessage: "You control what goes in a blog post, so {lineBreak} let your imagination run wild."
    },
    iconDescription: {
        id: "template-preview.custom.blog-post.icon.description",
        defaultMessage: "Blog post"
    }
});
const $de4db65843ec2cc7$export$54466272bf194c87 = 'com.atlassian.confluence.plugins.confluence-create-content-plugin:create-blog-post';
const $de4db65843ec2cc7$export$2de249724bf9bee6 = (0, $gmMgo.default)(({ intl: intl })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // We're not using <ExperienceSuccess /> because this component isn't actually de-mounting properly, the current logic just hides it.
    experienceTracker.succeed({
        name: (0, $irVI7.TEMPLATE_PREVIEW_EXPERIENCE)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2dIMm.PreviewMessage), {
        title: intl.formatMessage($de4db65843ec2cc7$export$a7357cdd1f0b0168.title),
        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$de4db65843ec2cc7$export$a7357cdd1f0b0168.message,
            values: {
                lineBreak: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)
            }
        }),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ctTlX))),
        iconDescription: intl.formatMessage($de4db65843ec2cc7$export$a7357cdd1f0b0168.iconDescription),
        iconSize: "medium",
        testId: "template-preview-custom-blog-post-preview"
    });
});
module.exports["BLOG_POST_ITEM_MODULE_COMPLETE_KEY"] = $de4db65843ec2cc7$export$54466272bf194c87;
module.exports["CustomBlogPostPreview"] = $de4db65843ec2cc7$export$2de249724bf9bee6;

});

parcelRegister("ctTlX", function(module, exports) {
module.exports = new URL("blogPostIcon.e3cb4562.svg", import.meta.url).toString();

});


//# sourceMappingURL=TemplatePreview.3cdd5fcb.js.map
